/* tslint:disable */
/* eslint-disable */
/**
 * Admin Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface RoleDTO
 */
export interface RoleDTO  {
    /**
     * 
     * @type {number}
     * @memberof RoleDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RoleDTO
     */
    role?: string;
}

/**
 * Check if a given object implements the RoleDTO interface.
 */
export function instanceOfRoleDTO(value: object): value is RoleDTO {
    return true;
}

export function RoleDTOFromJSON(json: any): RoleDTO {
    return RoleDTOFromJSONTyped(json, false);
}

export function RoleDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'role': json['role'] == null ? undefined : json['role'],
    };
}

export function RoleDTOToJSON(json: any): RoleDTO {
    return RoleDTOToJSONTyped(json, false);
}

export function RoleDTOToJSONTyped(value?: RoleDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'role': value['role'],
    };
}


